import { useCallback, useEffect, useState } from 'react';

// Theme: 'light' | 'dark' | 'system'. Persisted in localStorage('km-theme') and
// applied as <html data-theme="dark|light"> so theme.css tokens switch.
const KEY = 'km-theme';
const mq = () => window.matchMedia('(prefers-color-scheme: dark)');

export function resolveTheme(pref) {
  return pref === 'system' ? (mq().matches ? 'dark' : 'light') : pref;
}

export function useTheme(defaultPref = 'light') {
  const [pref, setPref] = useState(() => {
    try { return localStorage.getItem(KEY) || defaultPref; } catch { return defaultPref; }
  });
  const [, bump] = useState(0);

  useEffect(() => {
    document.documentElement.dataset.theme = resolveTheme(pref);
    const m = mq(), h = () => { if (pref === 'system') { document.documentElement.dataset.theme = resolveTheme(pref); bump((n) => n + 1); } };
    m.addEventListener('change', h);
    return () => m.removeEventListener('change', h);
  }, [pref]);

  const set = useCallback((p) => { setPref(p); try { localStorage.setItem(KEY, p); } catch { /* private mode */ } }, []);
  const toggle = useCallback(() => set(resolveTheme(pref) === 'dark' ? 'light' : 'dark'), [pref, set]);
  return { pref, theme: resolveTheme(pref), set, toggle, isDark: resolveTheme(pref) === 'dark' };
}
